import { ThemeProvider } from "@emotion/react";
import { RouterProvider } from "react-router-dom";
// import "./App.css";
import { QueryClient, QueryClientProvider } from "react-query";
import router from "./Routes/index";
import  theme  from "./theme/theme";
import { Box } from "@mui/material";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

function App() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
      },
    },
  });

  return (
    <Box className="App">
      <ThemeProvider theme={theme}>
        <QueryClientProvider client={queryClient}>
          <RouterProvider router={router} />
        </QueryClientProvider>
        <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
      </ThemeProvider>
    </Box>
  );
}

export default App;